// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1QOer","alert":"SettungsInbox_alert__5Yo6e"};